import { createContext, useContext } from 'react';

interface FormFieldContextValue {
  error: boolean;
}

/** Lets components inside a Form.Field (e.g. Checkbox) style themselves when the field has an error */
export const FormFieldContext = createContext<FormFieldContextValue>({
  error: false,
});

export const useFormField = () => useContext(FormFieldContext);
